import DiffMatchPatch from 'diff-match-patch'

function escapeHtmlString(str: string): string {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

function textDiff(
  previous: string,
  next: string,
  config?: {
    useEmptyString?: boolean
    emptyStringPlaceholder?: string
    compare?: boolean
  },
): string {
  const dmp = new DiffMatchPatch()
  const diffs = dmp.diff_main(previous || '', next || '')
  dmp.diff_cleanupSemantic(diffs)

  const options = {
    useEmptyString: true,
    emptyStringPlaceholder: ' ',
    compare: true,
    ...config,
  }

  const addedClass = options.compare ? ' diff-text--added' : ''
  const removedClass = options.compare ? ' diff-text--removed' : ''

  if (options?.useEmptyString) {
    if (!previous) {
      return `<del role="deletion" class="diff-text${removedClass}">${escapeHtmlString(options.emptyStringPlaceholder)}</del><ins role="insertion" class="diff-text${addedClass}">${escapeHtmlString(next)}</ins>`
    } else if (!next) {
      if (options.compare) {
        return `<del role="deletion" class="diff-text${removedClass}">${escapeHtmlString(previous)}</del><ins role="insertion" class="diff-text${addedClass}">${escapeHtmlString(options.emptyStringPlaceholder)}</ins>`
      } else {
        return `<del role="deletion" class="diff-text${removedClass}">${escapeHtmlString(options.emptyStringPlaceholder)}</del>`
      }
    }
  }

  let changedText = ''

  for (const [operation, text] of diffs) {
    if (operation === 0) {
      changedText += text
    } else if (operation === -1) {
      if (options.compare) {
        changedText += `<del role="deletion" class="diff-text${removedClass}">${escapeHtmlString(text)}</del>`
      } else {
        changedText += `<del role="deletion" class="diff-text${removedClass}"> </del>`
      }
    } else {
      changedText += `<ins role="insertion" class="diff-text${addedClass}">${escapeHtmlString(text)}</ins>`
    }
  }

  return changedText
}

export { textDiff, escapeHtmlString }
